import React from 'react';
import { SkeletonContainer, SkeletonAnimation } from './SkeletonLoader.styles';

export type SkeletonLoaderProps = {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  margin?: string;
  className?: string;
};

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  width = '100%',
  height = '16px',
  borderRadius = '4px',
  margin = '0',
  className,
}) => {
  return (
    <SkeletonContainer
      className={className}
      style={{
        width,
        height,
        borderRadius,
        margin,
      }}
    >
      <SkeletonAnimation />
    </SkeletonContainer>
  );
};

export default SkeletonLoader;
